import { Routes } from '@angular/router';
import { ComissoesContent } from '@/features/comissoes/comissoes-content';
import { ComissoesRelatoriosContent } from '@/features/comissoes/relatorios/comissoes-relatorios-content';
import { COMISSOES_ROUTES } from '@/features/comissoes/comissoes.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

const R = COMISSOES_ROUTES.RELATORIOS;

/**
 * Relatórios do módulo Comissões — mesma estrutura de `/arrecadacao/relatorios`:
 * `ComissoesContent` (menu lateral) → `ComissoesRelatoriosContent` (listagem de cards + outlet).
 * Sem redirect no root: `/comissoes/relatorios` exibe a listagem; cada grupo/relatório é um filho.
 */
export const comissoesRelatoriosRoutes: Routes = [
    {
        path: R.ROOT,
        component: ComissoesContent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Relatórios', permission: PERMISSOES.comissoes.relatorios.escopo },
        children: [
            {
                path: '',
                component: ComissoesRelatoriosContent,
                children: [
                    {
                        path: R.CCT_GRUPOS,
                        data: { breadcrumb: 'Comissões e Câmaras Técnicas e Grupos de Trabalho' },
                        children: [
                            {
                                path: R.SINTETICO,
                                loadComponent: () => import('@/features/comissoes/relatorios/components/comissoes-cct-sintetico/comissoes-cct-sintetico').then((m) => m.ComissoesCctSintetico),
                                data: { breadcrumb: 'Sintético' }
                            },
                            {
                                path: R.ANALITICO,
                                loadComponent: () => import('@/features/comissoes/relatorios/components/comissoes-cct-analitico/comissoes-cct-analitico').then((m) => m.ComissoesCctAnalitico),
                                data: { breadcrumb: 'Analítico' }
                            },
                            {
                                path: R.ENCERRADOS,
                                loadComponent: () => import('@/features/comissoes/relatorios/components/comissoes-cct-encerrados/comissoes-cct-encerrados').then((m) => m.ComissoesCctEncerrados),
                                data: { breadcrumb: 'Encerrados' }
                            }
                        ]
                    },
                    {
                        path: R.COMPOSICAO,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/composicao-comissoes/composicao-comissoes').then((m) => m.ComposicaoComissoes),
                        data: { breadcrumb: 'Composição de Comissões, Câmaras Técnicas e Grupos de Trabalho' }
                    },
                    {
                        path: R.FREQUENCIA,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/frequencia-comissoes/frequencia-comissoes').then((m) => m.FrequenciaComissoes),
                        data: { breadcrumb: 'Frequência' }
                    },
                    {
                        path: R.MEMBROS_POR_UF,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/membros-por-uf-comissoes/membros-por-uf-comissoes').then((m) => m.MembrosPorUfComissoes),
                        data: { breadcrumb: 'Membros por Unidade da Federação' }
                    },
                    {
                        path: R.PARTICIPACAO_MEMBRO,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/participacao-membro-comissoes/participacao-membro-comissoes').then((m) => m.ParticipacaoMembroComissoes),
                        data: { breadcrumb: 'Participação de Membro' }
                    },
                    {
                        path: R.PRODUCAO_ATAS,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/producao-atas-comissoes/producao-atas-comissoes').then((m) => m.ProducaoAtasComissoes),
                        data: { breadcrumb: 'Produção de Atas' }
                    },
                    {
                        path: R.CONFIRMACOES_REUNIAO,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/confirmacoes-reuniao/confirmacoes-reuniao').then((m) => m.ConfirmacoesReuniao),
                        data: { breadcrumb: 'Confirmações de Reunião' }
                    },
                    {
                        path: R.REQUISICAO_MATERIAL_SEMANAL,
                        loadComponent: () => import('@/features/comissoes/relatorios/components/requisicao-material-semanal/requisicao-material-semanal').then((m) => m.RequisicaoMaterialSemanal),
                        data: { breadcrumb: 'Requisição de Material Semanal' }
                    }
                ]
            }
        ]
    }
];
